import { cn } from '../../utils/cn'

const navButtonClasses = {
  base: 'group flex w-full items-center rounded-2xl border text-sm font-semibold transition',
  open: 'justify-between px-4 py-3 text-left',
  active: 'border-transparent bg-ink text-white shadow-sm',
  inactive:
    'border-border/70 bg-white/70 text-ink hover:-translate-y-0.5 hover:border-ink/10 hover:bg-white',
}

const navStatusClasses = {
  base: 'h-2 w-2 rounded-full',
  active: 'bg-accent-strong',
  inactive: 'bg-border',
}

export const sidebarClasses = {
  // スクロールはメニューだけに持たせる。全体をスクロールさせると、はみ出した分だけ
  // ログアウトが画面外へ出てしまい、サイドバー上でホイールを回すまで押せなくなる。
  container:
    'hidden w-full flex-col gap-6 border border-white/70 bg-white/85 p-6 shadow-card backdrop-blur-sm lg:fixed lg:inset-y-0 lg:left-0 lg:flex lg:w-[260px] lg:overflow-hidden lg:pr-5',
  drawerPanel:
    'flex h-full w-[280px] max-w-[85vw] flex-col gap-6 overflow-hidden bg-white p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] shadow-card',
  drawerCloseButton:
    'flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-border/70 bg-white/70 text-ink transition hover:border-ink/10 hover:bg-white',
  header: 'flex w-full items-center justify-between gap-3',
  brand: 'flex items-center gap-3',
  // min-h-0 が無いとflex itemが内容の高さより縮まず、スクロールできないまま溢れる
  menuSection: 'grid min-h-0 flex-1 content-start gap-3 overflow-y-auto',
  menuLabel: 'text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-muted',
  navButton: ({ isActive }: { isActive: boolean }) =>
    cn(
      navButtonClasses.base,
      navButtonClasses.open,
      isActive ? navButtonClasses.active : navButtonClasses.inactive,
    ),
  // lg 未満（モバイルドロワー）だけ 24px に大きくする。lg: で 20px に戻す書き方にしないのは、
  // PC のサイドバーの CSS に触れないため（w-6 h-6 を内蔵するアイコンがあり、lg: で縮んでしまう）
  navIcon: (isActive: boolean) =>
    cn(
      'h-5 w-5 max-lg:h-6 max-lg:w-6',
      isActive ? 'text-white' : 'text-muted group-hover:text-ink',
    ),
  navStatus: (isActive: boolean) =>
    cn(
      navStatusClasses.base,
      isActive ? navStatusClasses.active : navStatusClasses.inactive,
    ),
  footer: 'mt-auto grid gap-3 border-t border-border/60 pt-4',
}
